import React, {FC, useEffect, useState} from "react";
import {useAxios} from "../../utils/hooks";
import {openNotification} from "../../utils/openNotification";
import useSafeState from "../../utils/safe-state";
import {Trans} from "@lingui/macro";
import Drawer from "../../components/drawer/drawer";
import NewUserDrawer from "../../forms/new-user-drawer";
import {AxiosError, AxiosResponse} from "axios";
import {Breadcrumb, Button, Popconfirm, Tooltip} from "antd";
import {EditOutlined, PlusOutlined, RedoOutlined, UserAddOutlined} from "@ant-design/icons";
import {DeleteTwoTone} from "@ant-design/icons/lib";
import DtoTable from "../../components/dto-table/dto-table";
import UsersListModel from "../../models/users/user-list-model"
import RoleSettingForm from "../../forms/role-setting-form/role-setting-form";
import {antdContext} from "../../utils/antdContext";

const UserManagementScreen: FC = () => {

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [loading, setLoading] = useSafeState(false);
    const [trigger, setTrigger] = useSafeState(false);
    const [actUserRole, setActUserRole] = useSafeState();
    const [allRoles, setAllRoles] = useSafeState([]);
    const roleTitle = antdContext('Please choose a role!');
    const roleSetting = RoleSettingForm({
        title: roleTitle,
        children: <span />,
        customClose: () => setTrigger(function(prev) { return !prev; }),
    });
    const userText = <Trans>New User</Trans>

    const newUserDrawer = Drawer(
        {
            title: userText,
            children:
                <NewUserDrawer/>,
            customClose: () => setTrigger(function(prev) { return !prev; })
        }
    );

    useEffect(() => {


    }, []);

    const getUserRoles = (record:any, allRoles: any) => {
        if(axiosInstance.current != null) {
            setLoading(true);
            axiosInstance.current.get("/resource/userrole/get-user-roles?userName=" + record.loginName, {})
                .then(function (response : AxiosResponse<any>) {
                    roleSetting.showPromiseConfirm({
                        role: response.data,
                        roles: allRoles,
                        userId: record.id,
                        username: record.username,
                    });

                }).catch(function (error :AxiosError) {
                console.log(error)
            });
        }
    }

    const deleteRecord = (record:any) => {
        if(axiosInstance.current != null) {
            setLoading(true);
            axiosInstance.current.delete("/resource/user/deleterecord?userName=" + record.loginName, {})
                .then(function (response : AxiosResponse<any>) {
                    setLoading(false);
                    openNotification('success', 'Successfully deleted.')
                    setTrigger(function(prev) { return !prev; });
                }).catch(function (error :AxiosError) {
                let errResp = JSON.parse(JSON.stringify(error.response));
                let errMessage = errResp.data.message;
                openNotification('error',errMessage);
                console.log(error)
                setLoading(false);
            });
        }
    }

    const resetPassword = (record:any) => {
        if(axiosInstance.current != null) {
            setLoading(true);
            axiosInstance.current.put("/resource/user/reset-password?userName=" + record.loginName, {})
                .then(function (response : AxiosResponse<any>) {
                    setLoading(false);
                    openNotification('success', 'Successfully deleted.')
                    setTrigger(function(prev) { return !prev; });
                }).catch(function (error :AxiosError) {
                let errResp = JSON.parse(JSON.stringify(error.response));
                let errMessage = errResp.data.message;
                openNotification('error',errMessage);
                console.log(error)
                setLoading(false);
            });
        }
    }

    const action =  (record: any) => {

        return (

            <>
                <Tooltip title={<Trans>Add Rights</Trans>}>
                    <UserAddOutlined  className={"ActionButtons"} style={{color: "#40a9ff"}} onClick={()=> {

                        if (axiosInstance.current != null) {
                            setLoading(true);
                            axiosInstance.current.get("/resource/roles/get-all-roles", {})
                                .then(function (response: AxiosResponse<any>) {
                                    getUserRoles(record, response.data)
                                }).catch(function (error: AxiosError) {
                                console.log(error)
                            });
                        }
                    }
                    }/>
                </Tooltip>
                <Tooltip title={<Trans>Password Reset</Trans>}>
                    <Popconfirm  title={<Trans>Are you sure want to reset password?</Trans>}
                                 onConfirm={() => resetPassword(record)}
                                 okText={<Trans>Yes</Trans>}
                                 cancelText={<Trans>No</Trans>}>
                        <RedoOutlined  className={"ActionButtons"} style={{color: "#40a9ff"}}/>
                    </Popconfirm>
                </Tooltip>
                <Tooltip  title={<Trans>Remove</Trans>}>
                    <Popconfirm  title={<Trans>Are you sure want to delete record?</Trans>}
                                 onConfirm={() => deleteRecord(record)}
                                 okText={<Trans>Yes</Trans>}
                                 cancelText={<Trans>No</Trans>}>
                        <DeleteTwoTone className={"ActionButtons"} twoToneColor={"red"}/>
                    </Popconfirm>
                </Tooltip>
            </>
        )};

    const actions = {
        width: 180,
        render: (text: string, record: any) => action(record),
        title: '',
        fixed: 'right',
        align: 'center'
    };


    return (<>

            <>

                <Breadcrumb style={{ marginBottom: 10 }}>
                    <Breadcrumb.Item><Trans id={'Home'}/></Breadcrumb.Item>
                    <Breadcrumb.Item><Trans id={'User Management'}></Trans></Breadcrumb.Item>
                </Breadcrumb>
                <DtoTable
                    tableHeader={<Button type={"primary"} onClick={()=>newUserDrawer.open("", {
                        mode: 'AddNew'
                    })
                    } style={{float: "left", marginRight:10}}><PlusOutlined /><span><Trans>Add new</Trans></span></Button>}
                    model={UsersListModel}
                    action={actions}
                    trigger={trigger}
                    allowRefreshButton={true}
                    allowExport={true}
                    pageSize={100}
                    scroll={{ x: 1300, y: "65vh" }}
                />
                {newUserDrawer.component}
            </>


        </>
    )
}
export default UserManagementScreen;
